/*
 *
 * DashBoard constants
 *
 */

export const GET_PROVIDER_SEARCH_REQUEST_SENT = 'src/Dashboard/GET_PROVIDER_SEARCH_REQUEST_SENT';
export const GET_PROVIDER_SEARCH_REQUEST_SUCCEED = 'src/Dashboard/GET_PROVIDER_SEARCH_REQUEST_SUCCEED';
export const GET_PROVIDER_SEARCH_REQUEST_FAILED = 'src/Dashboard/GET_PROVIDER_SEARCH_REQUEST_FAILED';

export const GET_PROVIDER_FILTERS_REQUEST_SENT = 'src/Dashboard/GET_PROVIDER_FILTERS_REQUEST_SENT';
export const GET_PROVIDER_FILTERS_REQUEST_SUCCEED = 'src/Dashboard/GET_PROVIDER_FILTERS_REQUEST_SUCCEED';
export const GET_PROVIDER_FILTERS_REQUEST_FAILED = 'src/Dashboard/GET_PROVIDER_FILTERS_REQUEST_FAILED';

export const GET_PROVIDER_PATIENTS_RANGE_REQUEST_SENT = 'src/Dashboard/GET_PROVIDER_PATIENTS_RANGE_REQUEST_SENT';
export const GET_PROVIDER_PATIENTS_RANGE_REQUEST_SUCCEED = 'src/Dashboard/GET_PROVIDER_PATIENTS_RANGE_REQUEST_SUCCEED';
export const GET_PROVIDER_PATIENTS_RANGE_REQUEST_FAILED = 'src/Dashboard/GET_PROVIDER_PATIENTS_RANGE_REQUEST_FAILED';

export const ADD_NEW_PATIENT_REQUEST_SENT = 'src/Dashboard/ADD_NEW_PATIENT_REQUEST_SENT';
export const ADD_NEW_PATIENT_REQUEST_SUCCEED = 'src/Dashboard/ADD_NEW_PATIENT_REQUEST_SUCCEED';
export const ADD_NEW_PATIENT_REQUEST_FAILED = 'src/Dashboard/ADD_NEW_PATIENT_REQUEST_FAILED';

export const GET_EHR_ACTIVITY_REQUEST_SENT = 'src/Dashboard/GET_EHR_ACTIVITY_REQUEST_SENT';
export const GET_EHR_ACTIVITY_REQUEST_SUCCEED = 'src/Dashboard/GET_EHR_ACTIVITY_REQUEST_SUCCEED';
export const GET_EHR_ACTIVITY_REQUEST_FAILED = 'src/Dashboard/GET_EHR_ACTIVITY_REQUEST_FAILED';

export const GET_APPOINTMENTS_SEARCH_REQUEST_SENT = 'src/Dashboard/GET_APPOINTMENTS_SEARCH_REQUEST_SENT';
export const GET_APPOINTMENTS_SEARCH_REQUEST_SUCCEED = 'src/Dashboard/GET_APPOINTMENTS_SEARCH_REQUEST_SUCCEED';
export const GET_APPOINTMENTS_SEARCH_REQUEST_FAILED = 'src/Dashboard/GET_APPOINTMENTS_SEARCH_REQUEST_FAILED';

export const GET_APPOINTMENTS_SEARCH_WITHIN_RANGE_REQUEST_SENT = 'src/Dashboard/GET_APPOINTMENTS_SEARCH_WITHIN_RANGE_REQUEST_SENT';
export const GET_APPOINTMENTS_SEARCH_WITHIN_RANGE_REQUEST_SUCCEED = 'src/Dashboard/GET_APPOINTMENTS_SEARCH_WITHIN_RANGE_REQUEST_SUCCEED';
export const GET_APPOINTMENTS_SEARCH_WITHIN_RANGE_REQUEST_FAILED = 'src/Dashboard/GET_APPOINTMENTS_SEARCH_WITHIN_RANGE_REQUEST_FAILED';

export const SET_SELECTED_FILTER_ID = 'src/Dashboard/SET_SELECTED_FILTER_ID';

export const RESET_STATE = 'src/Dashboard/RESET_STATE';
